import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import Select from "react-select"
import classnames from "classnames"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import {
  fetchStallList,
  fetchPvsDetails,
  submitStallBooking,
  getBazaarDetails,
} from "../../../redux/actions/pvs"
import { toast } from "react-toastify"
import { getProductList } from "../../../redux/actions/user"
import {
  FETCH_PVS_DETAILS_RESET,
  SUBMIT_BOOKING_RESET,
  GET_BAZAAR_DETAILS_RESET,
} from "../../../redux/types/pvs"
import TagInput from "components/TagInput"
import ConfirmPopup from "components/ConfirmPopup"
import ErrorPopup from "components/ErrorPopup"
import * as Yup from "yup"

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}
const BazaarRegistration = () => {
  document.title = "Bazaar Registration | PULA"
  const query = useQuery()
  const bazaarId = query.get("id")
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isErrorOpen, setIsErrorOpen] = useState(false)
  const [isErrorMessage, setIsErrorMessage] = useState("")
  // Each seller has its own PVS search box. They used to share one value,
  // so typing seller 2's number overwrote seller 1's box.
  const [pvsSearch, setPvsSearch] = useState({
    seller1: { group: "PVS_2018_", number: "" },
    seller2: { group: "PVS_2018_", number: "" },
  })
  const [activeSeller, setActiveSeller] = useState("")
  const setPvsSearchField = (seller, field, value) =>
    setPvsSearch(prev => ({
      ...prev,
      [seller]: { ...prev[seller], [field]: value },
    }))
  const [productList, setProductList] = useState([])
  const [stallList, setStallList] = useState([])
  const [activeForm, setActiveForm] = useState("")
  const [selectedBazaar, setselectedBazaar] = useState(null)
  const [nextBazaar, setNextBazaar] = useState(null)
  const [confirmMessage, setConfirmMessage] = useState("")
  const [requestBody, setRequestBody] = useState("")
  const [isOpen, setisOpen] = useState(false)
  const [nextBazaarPopUpIsOpen, setNextBazaarPopUpIsOpen] = useState(false)

  const [Event1Tab, setEvent1Tab] = useState("1")
  const [stallType, setStallType] = useState("individual") // "individual" or "shared"\

  const [seller1Event1Status, setSeller1Event1Status] = useState(false)
  const [seller2Event1Status, setSeller2Event1Status] = useState(false)

  // Header Bar PVS Details showing
  const [isPvsDetailsLoaded, setIsPvsDetailsLoaded] = useState(false)


  const token = useSelector(state => state.auth.token)
  const products = useSelector(state => state.user.products)
  const stalls = useSelector(state => state.pvs.stallList)
  const pvsDetails = useSelector(state => state.pvs.pvsDetails)
  const bazaarList = useSelector(state => state.pvs.bazaarList)
  const fetchPvsDetailScreen = useSelector(
    state => state.screens.pvs.fetchPvsDetail
  )
  const submitBookingScreen = useSelector(
    state => state.screens.pvs.submitBooking
  )
  const getBazaarDetailScreen = useSelector(
    state => state.screens.pvs.getBazaarDetail
  )

  // Sharing add-on cost: use the add-on with id=1 from the bazaar's add_ons array.
  // Falls back to 4000 if not configured.
  console.log('bazaar details...', getBazaarDetailScreen);
  

  const sharingAddOn = getBazaarDetailScreen?.data?.add_ons?.find(
    a => a.item_id === 1
  )
  console.log("sharing add on...", sharingAddOn)
  
  const sharingCost = Number(sharingAddOn?.item_total_cost) || 4000

  useEffect(() => {
    if (bazaarId) {
      dispatch(getBazaarDetails(bazaarId))
    }
    return () => {
      dispatch({ type: GET_BAZAAR_DETAILS_RESET })
    }
  }, [bazaarId])

  useEffect(() => {
    if (bazaarId && bazaarList && bazaarList.length > 0) {
      let currentIndex = bazaarList.findIndex(
        bazaar => bazaar.enc_bazaar_id === bazaarId
      )
      if (currentIndex >= 0) {
        setselectedBazaar(bazaarList[currentIndex])
        setNextBazaar(bazaarList[currentIndex - 1])
      }
    }
  }, [bazaarId, bazaarList])

  useEffect(() => {
    if (submitBookingScreen.success) {
      toast.success(submitBookingScreen.message)
      dispatch({ type: SUBMIT_BOOKING_RESET })
      seller1Event1.setSubmitting(false)
      seller2Event1.setSubmitting(false)
      if (nextBazaar) {
        setNextBazaarPopUpIsOpen(true)
      } else {
        navigate("/all-bazaar-list")
      }
    }
    if (submitBookingScreen.error) {
      // toast.error(submitBookingScreen.error)
      setIsErrorMessage(submitBookingScreen.error)
      setIsErrorOpen(true)
      dispatch({ type: SUBMIT_BOOKING_RESET })
      seller1Event1.setSubmitting(false)
      seller2Event1.setSubmitting(false)
    }
  }, [submitBookingScreen])

  useEffect(() => {
    if (selectedBazaar) {
      dispatch(
        fetchStallList(
          {
            enc_bazaar_id: selectedBazaar.enc_bazaar_id,
          },
          token
        )
      )
      dispatch(getProductList({ offset: 1 }, token))
    }
  }, [selectedBazaar])

  useEffect(() => {
    if (fetchPvsDetailScreen.success) {
      toast.success(fetchPvsDetailScreen.message)
      if (activeSeller) setPvsSearchField(activeSeller, "number", "")
      dispatch({ type: FETCH_PVS_DETAILS_RESET })
      if (pvsDetails) {
        let selectedProducts = []
        if (pvsDetails.product_ids) {
          const ids = pvsDetails.product_ids.split(",")
          selectedProducts = productList.filter(prod =>
            ids.includes(prod.value.toString())
          )
          // activeForm.setFieldValue("products", selectedProducts)
        }
        activeForm.setValues({
          name: `${pvsDetails.first_name} ${pvsDetails.last_name}`,
          email: pvsDetails.email_id,
          whatsAppNo: pvsDetails.mobile_no,
          contactNo: pvsDetails.contact_no,
          pvsCardNumber: pvsDetails.pvs_card_number,
          products: selectedProducts,
          stalls: activeForm.values.stalls,
          other_products: [],
        })
        setIsPvsDetailsLoaded(true)
      }
    }
    if (fetchPvsDetailScreen.error) {
      toast.error(fetchPvsDetailScreen.error)
      dispatch({ type: FETCH_PVS_DETAILS_RESET })
      setIsPvsDetailsLoaded(false)
    }
  }, [fetchPvsDetailScreen])

  useEffect(() => {
    if (products && products.length > 0) {
      const prodOptions = products.map(prod => ({
        label: prod.product_name,
        value: prod.product_id,
      }))
      setProductList(prodOptions)
    }
  }, [products])

  useEffect(() => {
    // Always replace, including with an empty list, so a sold-out bazaar
    // doesn't keep showing the previous bazaar's stalls
    const stallOptions = (stalls || []).map(stall => ({
      ...stall,
      label: stall.stall_number,
      value: stall.enc_stall_id,
    }))
    setStallList(stallOptions)
  }, [stalls])

  const updateStalls = stalls => {
    let newStalls = []
    stalls.map(stall =>
      newStalls.push({
        ...stall,
        base_price: stall.base_price / 2,
        two_sides_price: stall.two_sides_price / 2,
        stall_cost: stall.base_price / 2 + stall.two_sides_price / 2,
      })
    )
    return newStalls
  }

  useEffect(() => {
    let requestBody = null
    let seller1Event1Stalls = seller1Event1.values.stalls
    let seller2Event1Stalls = seller2Event1.values.stalls
    if (stallType === "shared") {
      seller1Event1Stalls = updateStalls(seller1Event1.values.stalls)
      seller2Event1Stalls = updateStalls(seller2Event1.values.stalls)
    }

    if (stallType === "shared") {
      // check seller1Event1Status and seller2Event1Status
      if (seller1Event1Status && seller2Event1Status) {
        requestBody = {
          bazaar: [
            {
              stall_category: stallType, // individual and shared
              enc_bazaar_id: selectedBazaar.enc_bazaar_id,
              seller: [
                {
                  seller_name: seller1Event1.values.name,
                  seller_email_id: seller1Event1.values.email,
                  seller_whatsapp_no: seller1Event1.values.whatsAppNo,
                  seller_contact_no: seller1Event1.values.contactNo,
                  pvs_card_number: seller1Event1.values.pvsCardNumber,
                  product_ids: seller1Event1.values.products
                    .map(p => p.value)
                    .join(","),
                  // Tags are plain strings (see TagInput), not { value } objects
                  other_products: seller1Event1.values.other_products.join(","),
                },
                {
                  seller_name: seller2Event1.values.name,
                  seller_email_id: seller2Event1.values.email,
                  seller_whatsapp_no: seller2Event1.values.whatsAppNo,
                  seller_contact_no: seller2Event1.values.contactNo,
                  pvs_card_number: seller2Event1.values.pvsCardNumber,
                  product_ids: seller2Event1.values.products
                    .map(p => p.value)
                    .join(","),
                  // Tags are plain strings (see TagInput), not { value } objects
                  other_products: seller2Event1.values.other_products.join(","),
                },
              ],
              stall: seller1Event1Stalls,

              add_on: [
                {
                  item_name: sharingAddOn?.item_name ?? "Sharing",
                  item_cost: sharingCost,
                },
              ],
            },
          ],
        }
      }
    } else {
      // check seller1Event1Status
      if (seller1Event1Status) {
        requestBody = {
          bazaar: [
            {
              stall_category: stallType, // individual and shared
              enc_bazaar_id: selectedBazaar.enc_bazaar_id,
              seller: [
                {
                  seller_name: seller1Event1.values.name,
                  seller_email_id: seller1Event1.values.email,
                  seller_whatsapp_no: seller1Event1.values.whatsAppNo,
                  seller_contact_no: seller1Event1.values.contactNo,
                  pvs_card_number: seller1Event1.values.pvsCardNumber,
                  product_ids: seller1Event1.values.products
                    .map(p => p.value)
                    .join(","),
                  other_products: seller1Event1.values.other_products
                    .map(p => p)
                    .join(","),
                },
              ],
              stall: seller1Event1Stalls,
            },
          ],
        }
      }
    }

    if (requestBody) {
      let message = (
        <>
          <table className="table table-bordered table-sm mb-0">
            <tbody>
              <tr>
                <th colSpan={3}>
                  {
                    bazaarList.find(
                      val =>
                        requestBody.bazaar[0].enc_bazaar_id ===
                        val.enc_bazaar_id
                    ).bazaar_name
                  }
                </th>
              </tr>
              <tr>
                <td>Category:</td>
                <td>{requestBody.bazaar[0].stall_category}</td>
              </tr>
              <tr>
                <td>Sellers:</td>
                <td>
                  {requestBody.bazaar[0].seller.map((val, index) =>
                    index === 0 ? `${val.seller_name}, ` : `${val.seller_name}`
                  )}
                </td>
              </tr>
              <tr>
                <td>Stalls:</td>
                <td>
                  {requestBody.bazaar[0].stall.map((val, index) =>
                    index === 0
                      ? `${val.stall_number}, `
                      : `${val.stall_number}`
                  )}
                </td>
              </tr>
            </tbody>
          </table>
          {requestBody.bazaar.length > 1 && (
            <table className="table table-bordered table-sm mb-0">
              <tbody>
                <tr>
                  <th colSpan={3}>
                    {
                      bazaarList.find(
                        val =>
                          requestBody.bazaar[1].enc_bazaar_id ===
                          val.enc_bazaar_id
                      ).bazaar_name
                    }
                  </th>
                </tr>
                <tr>
                  <td>Category:</td>
                  <td>{requestBody.bazaar[1].stall_category}</td>
                </tr>
                <tr>
                  <td>Sellers:</td>
                  <td>
                    {requestBody.bazaar[1].seller.map((val, index) =>
                      index === 0
                        ? `${val.seller_name}, `
                        : `${val.seller_name}`
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Stalls:</td>
                  <td>
                    {requestBody.bazaar[1].stall.map((val, index) =>
                      index === 0
                        ? `${val.stall_number}, `
                        : `${val.stall_number}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        </>
      )

      setConfirmMessage(message)
      setRequestBody(requestBody)
      setisOpen(true)
    }
  }, [seller1Event1Status, seller2Event1Status])
  useEffect(() => {
    if (!isOpen) {
      setSeller1Event1Status(false)
      setSeller2Event1Status(false)
    }
  }, [isOpen])

  const toggleEvent1Tab = tab => {
    if (Event1Tab !== tab) setEvent1Tab(tab)
  }

  const onConfirm = () => {
    setisOpen(false)
    console.log("requestBody", requestBody)

    dispatch(submitStallBooking(requestBody, token))
    if (nextBazaar) {
      // setNextBazaarPopUpIsOpen(true)
    }
  }

  const onCopyToNextBazaar = () => {
    setNextBazaarPopUpIsOpen(false)
    setselectedBazaar(nextBazaar)
    setNextBazaar(null)
    dispatch(
      fetchStallList(
        {
          enc_bazaar_id: nextBazaar.enc_bazaar_id,
        },
        token
      )
    )
    dispatch(getBazaarDetails(nextBazaar.enc_bazaar_id))

    seller1Event1.setValues({
      ...seller1Event1.values,
      stalls: [],
      other_products: [],
    })
    if (stallType === "shared") {
      seller2Event1.setValues({
        ...seller2Event1.values,
        stalls: [],
        other_products: [],
      })
    }
    // TODO: Implement copy to next bazaar logic
  }

  const fetchPVSDetails = (form, seller) => {
    // One lookup at a time: the saga keeps only the latest request, so a
    // second Search while the first is loading silently dropped the first
    // seller's details (the "second seller goes blank" report)
    if (fetchPvsDetailScreen.loading) return
    const { group, number } = pvsSearch[seller]
    if (number) {
      setIsPvsDetailsLoaded(false)
      setActiveForm(form)
      setActiveSeller(seller)
      dispatch(
        fetchPvsDetails({ pvs_card_number: `${group}${number}` }, token)
      )
    } else {
      toast.error("Please enter PVS Number")
    }
  }
  const seller1Event1 = useFormik({
    initialValues: {
      name: "",
      email: "",
      whatsAppNo: "",
      contactNo: "",
      pvsCardNumber: "",
      stalls: [],
      products: [],
      other_products: [],
    },
    validate: values => {
      const errors = {}
      if (!values.name?.trim()) {
        errors.name = "Seller 1 Name Required"
      }
      // if (!values.email?.trim()) {
      //   errors.email = "Seller 1 Email Required"
      // } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      //   errors.email = "Seller 1 Email Invalid"
      // }
      if (!values.whatsAppNo?.trim()) {
        errors.whatsAppNo = "Seller 1 WhatsApp Number Required"
      }
      // if (!values.contactNo?.trim()) {
      //   errors.contactNo = "Seller 1 Contact Number Required"
      // }
      if (!values.pvsCardNumber?.trim()) {
        errors.pvsCardNumber = "Seller 1 PVS Card Number Required"
      }
      if (Array.isArray(values.products) && values.products.length === 0) {
        errors.products = "Seller 1 Products Required"
      }
      if (Array.isArray(values.stalls) && values.stalls.length === 0) {
        errors.stalls = "Stalls Required"
      }

      return errors
    },
    onSubmit: values => {
      setSeller1Event1Status(true)
    },
  })

  const seller2Event1 = useFormik({
    initialValues: {
      name: "",
      email: "",
      whatsAppNo: "",
      contactNo: "",
      pvsCardNumber: "",
      // stalls: [],
      products: [],
      other_products: [],
    },
    validate: values => {
      const errors = {}
      if (!values.name?.trim()) {
        errors.name = "Seller 2 Name Required"
      }
      if (!values.email?.trim()) {
        errors.email = "Seller 2 Email Required"
      } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email = "Seller 2 Email Invalid"
      }
      if (!values.whatsAppNo?.trim()) {
        errors.whatsAppNo = "Seller 2 WhatsApp Number Required"
      }
      // if (!values.contactNo?.trim()) {
      //   errors.contactNo = "Seller 2 Contact Number Required"
      // }
      if (!values.pvsCardNumber?.trim()) {
        errors.pvsCardNumber = "Seller 2 PVS Card Number Required"
      }
      if (Array.isArray(values.products) && values.products.length === 0) {
        errors.products = "Seller 2 Products Required"
      }
      return errors
    },
    onSubmit: values => {
      setSeller2Event1Status(true)
    },
  })

  useEffect(() => {
    let errorsArray = []

    if (seller1Event1.isSubmitting && seller1Event1.errors) {
      errorsArray = [...errorsArray, ...Object.values(seller1Event1.errors)]
    }

    if (seller2Event1.isSubmitting && seller2Event1.errors) {
      errorsArray = [...errorsArray, ...Object.values(seller2Event1.errors)]
    }
    if (errorsArray.length > 0) {
      let message = (
        <div>
          {/* <h5 className="mb-3">
            Please read the instructions carefully before you upload your
            documents
          </h5> */}
          <ul className="mb-0 ps-3">
            {errorsArray.map((error, index) => (
              <li key={index} className="mb-3">
                {error}
              </li>
            ))}
          </ul>
        </div>
      )
      setIsErrorMessage(message)
      setIsErrorOpen(true)
    }
  }, [seller1Event1, seller2Event1])

  const submitHandler = () => {
    console.log("submitHandler invoked...")

    try {
      seller1Event1.handleSubmit()
      if (stallType === "shared") {
        seller2Event1.handleSubmit()
      }
    } catch (error) {}
  }
  const optionGroup = [
    {
      options: [
        { label: "PVS_2018_", value: "PVS_2018_" },
        { label: "PVS_2021_", value: "PVS_2021_" },
      ],
    },
  ]

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3"></div>

        <>
          {/* Event 1 Stall Type */}
          <h4 className="h4 mb-3 nom-title">
            {selectedBazaar ? selectedBazaar.bazaar_name : ""}
          </h4>

          <div className="gridrow mb-2">
            <div className="cols-1">
              <Label className="d-block">
                Stall Type <span className="text-danger">*</span>
              </Label>
            </div>
            <div className="cols-2">
              <div className="form-check form-check-inline">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="stallType1"
                  id="individualStall1"
                  value="individual"
                  checked={stallType === "individual"}
                  onChange={e => {
                    setStallType(e.target.value)
                    toggleEvent1Tab("1")
                  }}
                />
                <Label className="form-check-label" htmlFor="individualStall">
                  Individual Stall
                </Label>
              </div>

              <div className="form-check form-check-inline">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="stallType"
                  id="sharedStall"
                  value="shared"
                  checked={stallType === "shared"}
                  onChange={e => {
                    setStallType(e.target.value)
                    seller2Event1.setFieldValue(
                      "stalls",
                      seller1Event1.values.stalls
                    )
                  }}
                />
                <Label className="form-check-label" htmlFor="sharedStall">
                  Shared Stall
                </Label>
              </div>
            </div>
          </div>

          {/* Event 1 Tabs */}
          <Card>
            <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified">
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({ active: Event1Tab === "1" })}
                  onClick={() => toggleEvent1Tab("1")}
                >
                  <i className="bx bx-user-circle font-size-20"></i>
                  <span className="seller-title font-size-18 d-sm-block">
                    Seller 1
                  </span>
                </NavLink>
              </NavItem>

              {stallType === "shared" && (
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({ active: Event1Tab === "2" })}
                    onClick={() => toggleEvent1Tab("2")}
                  >
                    <i className="bx bx-user"></i>
                    <span className="seller-title font-size-18 d-sm-block">
                      Seller 2
                    </span>
                  </NavLink>
                </NavItem>
              )}
            </Nav>

            <TabContent activeTab={Event1Tab} className="p-4">
              {/* Seller 1 Event 1 */}
              <TabPane tabId="1">
                <div className="row align-items-start justify-content-center align-items-center mb-4 bg-color-grey bazaar-pvs-section">
                  <div className="gridrow">
                    <div className="cols-1">
                      <div className="mb-2 searchpvs-wrapper">
                        <div className="searchpvs-input">
                          <div className="form-check form-check-inline">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="pvsGroup1"
                              id="pvs20181"
                              value="PVS_2018_"
                              checked={pvsSearch.seller1.group === "PVS_2018_"}
                              onChange={e => {
                                setPvsSearchField("seller1", "group", "PVS_2018_")
                              }}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="pvs20181"
                            >
                              PVS_2018_
                            </Label>
                          </div>
                        </div>
                        <div className="cols-2">
                          <div className="form-check form-check-inline">
                            <Input
                              className="form-check-input"
                              type="radio"
                              name="pvsGroup1"
                              id="pvs20211"
                              value="PVS_2021_"
                              checked={pvsSearch.seller1.group === "PVS_2021_"}
                              onChange={e => {
                                setPvsSearchField("seller1", "group", "PVS_2021_")
                              }}
                            />
                            <Label
                              className="form-check-label"
                              htmlFor="pvs20211"
                            >
                              PVS_2021_
                            </Label>
                          </div>
                        </div>
                        {/* <div className="cols-3">
                          
                        </div> */}
                      </div>
                      <div className="gridrow pvs-search-row">
                        <div>
                          <Input
                            id="pvsNumber1"
                            name="pvsNumber1"
                            type="text"
                            placeholder="Enter PVS Number *"
                            value={pvsSearch.seller1.number}
                            onChange={e =>
                              setPvsSearchField("seller1", "number", e.target.value.toUpperCase())
                            }
                          />
                          {/* {psvNumberError && (
                                <div className="text-danger small mt-1">
                                  {psvNumberError}
                                </div>
                              )} */}
                        </div>
                        <Button
                          type="button"
                          className="btn primary-button mb-0 mt-0"
                          onClick={() => {
                            fetchPVSDetails(seller1Event1, "seller1")
                          }}
                          disabled={fetchPvsDetailScreen.loading}
                        >
                          Search
                        </Button>
                      </div>
                    </div>
                    <div className="cols-1">
                      <div className="gridrow mb-1">
                        <Label className="font-size-16 mb-0">PVS No: </Label>
                        <span className="font-size-16">
                          {seller1Event1.values.pvsCardNumber}
                        </span>
                      </div>
                      <div className="gridrow mb-1">
                        <Label className="font-size-16 mb-0">Name:</Label>
                        <span className="font-size-16">
                          {seller1Event1.values.name}
                        </span>
                      </div>
                      <div className="gridrow mb-1">
                        <Label className="font-size-16 mb-0">
                          WhatsApp No <i className="ion ion-logo-whatsapp"></i>{" "}
                          :
                        </Label>
                        <span className="font-size-16">
                          {seller1Event1.values.whatsAppNo}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="border-top mt-4 pb-1"></div>
                </div>
                {/* Stall Details */}
                <div className="row">
                  <div className="col-12 col-md-6">
                    <Label>Products *</Label>
                    <Select
                      id="products"
                      name="product"
                      isMulti
                      options={productList}
                      classNamePrefix="select"
                      placeholder="Search the product..."
                      value={seller1Event1.values.products}
                      onChange={val =>
                        seller1Event1.setFieldValue("products", val)
                      }
                    />
                    {/* {seller1Event1.errors.products && (
                      <div className="text-danger small mt-1">
                        Required
                      </div>
                    )} */}
                  </div>
                  <div className="col-12 col-md-6">
                    <TagInput
                      title="Other Products"
                      tags={seller1Event1.values.other_products}
                      onChange={arr => {
                        seller1Event1.setFieldValue("other_products", arr)
                      }}
                    />
                    {seller1Event1.errors.other_products && (
                      <div className="text-danger small mt-1">
                        {seller1Event1.errors.other_products}
                      </div>
                    )}
                  </div>
                </div>
              </TabPane>

              {/* Seller 2 Event 1 */}
              {stallType === "shared" && (
                <TabPane tabId="2">
                  <div className="row align-items-start justify-content-center align-items-center mb-4 bg-color-grey bazaar-pvs-section">
                    <div className="gridrow">
                      <div className="cols-1">
                        <div className="mb-2 searchpvs-wrapper">
                          <div className="searchpvs-input">
                            <div className="form-check form-check-inline">
                              <Input
                                className="form-check-input"
                                type="radio"
                                name="pvsGroup2"
                                id="pvs20182"
                                value="PVS_2018_"
                                checked={pvsSearch.seller2.group === "PVS_2018_"}
                                onChange={e => {
                                  setPvsSearchField("seller2", "group", "PVS_2018_")
                                }}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="pvs20182"
                              >
                                PVS_2018_
                              </Label>
                            </div>
                          </div>
                          <div className="cols-2">
                            <div className="form-check form-check-inline">
                              <Input
                                className="form-check-input"
                                type="radio"
                                name="pvsGroup2"
                                id="pvs20212"
                                value="PVS_2021_"
                                checked={pvsSearch.seller2.group === "PVS_2021_"}
                                onChange={e => {
                                  setPvsSearchField("seller2", "group", "PVS_2021_")
                                }}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor="pvs20212"
                              >
                                PVS_2021_
                              </Label>
                            </div>
                          </div>
                          {/* <div className="cols-3">
                          
                        </div> */}
                        </div>
                        <div className="gridrow pvs-search-row">
                          <div>
                            <Input
                              id="pvsNumber2"
                              name="pvsNumber2"
                              type="text"
                              placeholder="Enter PVS Number *"
                              value={pvsSearch.seller2.number}
                              onChange={e =>
                                setPvsSearchField("seller2", "number", e.target.value.toUpperCase())
                              }
                            />
                            {/* {psvNumberError && (
                                <div className="text-danger small mt-1">
                                  {psvNumberError}
                                </div>
                              )} */}
                          </div>
                          <Button
                            type="button"
                            className="btn primary-button mb-0 mt-0"
                            onClick={() => {
                              fetchPVSDetails(seller2Event1, "seller2")
                            }}
                            disabled={fetchPvsDetailScreen.loading}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                      <div className="cols-1">
                        <div className="gridrow mb-1">
                          <Label className="font-size-16 mb-0">PVS No: </Label>
                          <span className="font-size-16">
                            {seller2Event1.values.pvsCardNumber}
                          </span>
                        </div>
                        <div className="gridrow mb-1">
                          <Label className="font-size-16 mb-0">Name:</Label>
                          <span className="font-size-16">
                            {seller2Event1.values.name}
                          </span>
                        </div>
                        <div className="gridrow mb-1">
                          <Label className="font-size-16 mb-0">
                            WhatsApp No{" "}
                            <i className="ion ion-logo-whatsapp"></i> :
                          </Label>
                          <span className="font-size-16">
                            {seller2Event1.values.whatsAppNo}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="border-top mt-4 pb-1"></div>
                  </div>
                  {/* Stall Details */}
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <Label>Products *</Label>
                      <Select
                        id="products"
                        name="product"
                        isMulti
                        options={productList}
                        classNamePrefix="select"
                        placeholder="Search the product..."
                        value={seller2Event1.values.products}
                        onChange={val =>
                          seller2Event1.setFieldValue("products", val)
                        }
                      />
                      {/* {seller2Event1.errors.products && (
                        <div className="text-danger small mt-1">
                          {seller2Event1.errors.products}
                        </div>
                      )} */}
                    </div>
                    <div className="col-12 col-md-6">
                      <TagInput
                        title="Other Products"
                        tags={seller2Event1.values.other_products}
                        onChange={arr => {
                          seller2Event1.setFieldValue("other_products", arr)
                        }}
                      />
                      {/* {seller2Event1.errors.other_products && (
                        <div className="text-danger small mt-1">
                          {seller2Event1.errors.other_products}
                        </div>
                      )} */}
                    </div>
                  </div>
                </TabPane>
              )}
            </TabContent>
          </Card>
          <Card>
            <div className="row p-4">
              <div className="col-12">
                <div className="row">
                  <div className="col-md-5 gap-3 d-flex flex-column mb-3">
                    <div>
                      <Label>Search & Select the Stall *</Label>
                      <Select
                        id="stalls"
                        name="stalls"
                        options={stallList}
                        classNamePrefix="select"
                        className="flex-fill"
                        placeholder="Search the stall..."
                        value={seller1Event1.values.stalls}
                        isMulti
                        onChange={val => {
                          seller1Event1.setFieldValue("stalls", val)
                        }}
                      />
                      {/* {seller1Event1.errors.stalls && (
                      <div className="text-danger small mt-1">
                        {seller1Event1.errors.stalls}
                      </div>
                    )} */}
                      <div className="d-flex gap-3 justify-content-center mt-4">
                        <Button
                          type="submit"
                          color="success"
                          className="btn btn-block font-size-16 "
                          onClick={submitHandler}
                        >
                          Book Slot
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 gap-3 d-flex flex-column mb-3">
                    <table className="table table-bordered table-sm mb-0">
                      <tbody>
                        <tr>
                          <th style={{ width: "200px" }}>Stall Number</th>
                          <th style={{ width: "200px" }}>Stall Type</th>
                          <th style={{ width: "200px" }}>Base Price</th>
                          <th style={{ width: "200px" }}>2 Sided Price</th>
                          <th style={{ width: "200px" }}>Stall Cost</th>
                        </tr>
                        {seller1Event1.values.stalls.map((value, index) => {
                          return (
                            <tr>
                              <td>{value.stall_number}</td>
                              <td>{value.stall_type}</td>
                              <td>{value.base_price}</td>
                              <td>{value.two_sides_price}</td>
                              <td>{value.stall_cost}</td>
                            </tr>
                          )
                        })}
                        {(() => {
                          // compute total stall cost
                          const total = (
                            seller1Event1.values.stalls || []
                          ).reduce((sum, s) => {
                            // handle cost as number or numeric string
                            const cost = Number(s?.stall_cost) || 0
                            return sum + cost
                          }, 0)

                          let addonTotal = total + sharingCost
                          let gst = 0
                          let grandTotal = 0
                          if (stallType === "shared") {
                            gst = addonTotal * 0.18
                            grandTotal = addonTotal + gst
                          } else {
                            gst = total * 0.18
                            grandTotal = total + gst
                          }

                          return (
                            <>
                              <tr className="table-primary fw-bold">
                                <th colSpan={4}>Subtotal</th>
                                <td>₹{total.toLocaleString()}</td>
                              </tr>
                              {stallType === "shared" && (
                                <tr className="table-primary fw-bold">
                                  <th colSpan={4}>
                                    Add-On (
                                    {sharingAddOn?.item_name ?? "Sharing"})
                                  </th>
                                  <td>₹{sharingCost.toLocaleString()}</td>
                                </tr>
                              )}
                              <tr className="table-primary fw-bold">
                                <th colSpan={4}>GST (18%)</th>
                                <td>₹{gst}</td>
                              </tr>
                              <tr className="table-primary fw-bold">
                                <th colSpan={4}>Grand Total</th>
                                <td>₹{grandTotal}</td>
                              </tr>
                            </>
                          )
                        })()}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </>
      </div>
      <ConfirmPopup
        title="Confirm"
        isOpen={isOpen}
        message={confirmMessage}
        onConfirm={onConfirm}
        toggle={() => {
          setisOpen(!isOpen)
        }}
      />
      <ConfirmPopup
        title="Copy to Next Event"
        isOpen={nextBazaarPopUpIsOpen}
        message={"Current selections will be copied to next event"}
        onConfirm={onCopyToNextBazaar}
        confirmText="Yes"
        cancelText="No"
        toggle={() => {
          setNextBazaarPopUpIsOpen(!nextBazaarPopUpIsOpen)
          navigate(-1)
        }}
      />
      <ErrorPopup
        isOpen={isErrorOpen}
        toggle={() => setIsErrorOpen(!isErrorOpen)}
        title="Fix following errors"
        message={isErrorMessage}
      />
    </div>
  )
}

export default BazaarRegistration
